module.exports = __webpack_public_path__ + "assets/img/2613.9eb6e1d7.png";